import log from 'loglevel';

import type DxfArrayScanner from '../DxfArrayScanner';
import type { IGroup, GroupValue } from '../DxfArrayScanner';
import { serializeGroupValue } from '../DxfArrayScanner';
import { groupIs } from '../ParseHelpers';
import { DXFSymbol } from '../constants';

type CodeValueEntry = [number, GroupValue];

export type IObject = {
  name: string;
  codeValueEntries: CodeValueEntry[];
};

const parseObject = (scanner: DxfArrayScanner): IObject => {
  let curr = scanner.lastReadGroup as IGroup<GroupValue>;
  const object: IObject = {
    name: curr.value as string,
    codeValueEntries: [],
  };
  curr = scanner.next();
  while (curr.code !== 0 && curr.value !== DXFSymbol.EOF) {
    object.codeValueEntries.push([curr.code, curr.value]);
    curr = scanner.next();
  }
  return object;
};

export const serializeObject = function* (
  c: IObject,
): IterableIterator<string> {
  //start of object
  yield '0';
  yield c.name;
  for (const [code, value] of c.codeValueEntries) {
    yield* serializeGroupValue(code, value as GroupValue);
  }
  //end of object
};

export const parseObjects = (scanner: DxfArrayScanner): IObject[] => {
  const objects: IObject[] = [];

  let curr = scanner.next();

  while (curr.value !== DXFSymbol.EOF) {
    if (groupIs(curr, 0, DXFSymbol.EndSec)) {
      break;
    }
    log.debug('object {');
    const object = parseObject(scanner);
    curr = scanner.lastReadGroup as IGroup<GroupValue>;
    log.debug('}');
    objects.push(object);
  }
  return objects;
};

export const serializeObjects = function* (
  objects: IObject[],
): IterableIterator<string> {
  //section name
  yield '2';
  yield DXFSymbol.Objects;

  for (const object of objects) {
    yield* serializeObject(object);
  }
};
